export default __webpack_public_path__ + "static/media/facebook.e1f1aa9b.png";